import { inject, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  cookieTools,
  addBar,
  hideBar,
  addGaScripts,
} from '@streeva/very-simple-cookie-consent'
import { buildCookieConsentBarHtml } from '@/helpers/cookieConsentBar'

const getBaseDomain = () => {
  const hostname = window.location.hostname
  if (hostname.includes('localhost')) return 'localhost'
  if (hostname.includes('onrender.com')) return hostname

  const match = hostname.match(/\w*\.*?(com|co.uk|net)$/gi)
  let domain = ''

  if (match) {
    domain = match[0]
  } else {
    domain = hostname
  }

  return `.${domain}`
}

const TAG = import.meta.env.VITE_GOOGLE_GTAG
const ct = cookieTools.init({
  domain: getBaseDomain(),
  expires: 365,
  sameSite: 'Lax',
})

/** Move keyboard focus to the consent dialog for screen reader users. */
function focusCookieConsentDialog() {
  requestAnimationFrame(() => {
    const acceptButton = document.querySelector(
      '.vs-cc-bar__button--primary'
    ) as HTMLButtonElement | null
    acceptButton?.focus({ preventScroll: true })
  })
}

const approveHandler = (e: Event) => {
  e.preventDefault()
  hideBar()
  ct.approve()
  addGaScripts(TAG)
}

const declineHandler = (e: Event) => {
  e.preventDefault()
  hideBar()
  ct.decline()
}

export default function useCookieConsent() {
  const { t } = useI18n()
  const rootSiteDomain = inject<string>(
    'rootSiteDomain',
    'https://www.swiftaid.co.uk'
  )
  const privacyPolicyLink = `${rootSiteDomain}/legal/cookies/`

  if (TAG === undefined) {
    console.warn('Missing Google Tag Manager ID')
  } else {
    onMounted(() => {
      if (!ct.hasMadeChoice()) {
        const barHtml = buildCookieConsentBarHtml({
          title: t('CookieConsent.Title'),
          bodyBeforeLink: t('CookieConsent.BodyBeforeLink'),
          policyLink: t('CookieConsent.PolicyLink'),
          bodyAfterLink: t('CookieConsent.BodyAfterLink'),
        })
        addBar(privacyPolicyLink, approveHandler, declineHandler, barHtml)
        focusCookieConsentDialog()
        return
      }

      if (ct.hasConsent()) {
        addGaScripts(TAG)
      }
    })
  }
}
